import React from 'react'
import './styleCalender.css';
import { Col, Row, Card, Input, FormGroup } from 'reactstrap';
import ApexCharts from 'react-apexcharts'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Doughnut } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";



export const ProgrammingDeposits = (props) => {

    const {
        loadingFinance, detailBranch, depositSerie, depositOptions, listMovements, listMovementsInvoice, number_format,
        leftContents, leftContents1, leftContents2, leftContents3, listDetailBranch, indicatorPatient, totalDepositSend, totalComplement,
        totalAmount, start_date, end_date, handleActions, handleInputChange,
        totalRecovered, totalCollected, filtereportPaymentsComplement, handlePayment, loadingDeposits
    } = props;


    const doughnutData = {
        labels: ["Flujo A", "Flujo B"],
        datasets: [
            {
                data: [totalRecovered, totalCollected],
                backgroundColor: ["#36a2eb", "#ff6384"],
                hoverBackgroundColor: ["#4bc0c0", "#ff9f40"],
                borderWidth: 1
            }
        ]
    };


    const doughnutOptions = {
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const value = context.raw;
                        return new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                        }).format(value);
                    }
                }
            },
            legend: {
                position: "bottom"
            }
        }
    };


    var _ticket = number_format(totalAmount / indicatorPatient, 2)

    const getBranchDetails = (_child) => {
        const _branchDetails = _child.id && listDetailBranch[_child.id]
            ? listDetailBranch[_child.id].filter(_detail => _detail.id_branch === _child.id && _detail.id_pay_method === 1)
            : [];
        return _branchDetails.length > 0 ? _branchDetails.find(_find => _find.id_branch === _child.id) : null;
    };

    const calculateTotal = (_child, _detail) => _detail ? (_detail.amount - _child.amount_collected) : 0;


    // * STYLES DATA TABLE
    const headerStyle =
    {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle =
    {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const centerStyle =
    {
        ...cellStyle,
        textAlign: "center",
        zIndex: 2
    };



    const barData = {
        labels: ["Total Programado", "Total Recuperado"],
        datasets: [
            {
                label: "Monto",
                data: [detailBranch[0]?.amount ?? 0, detailBranch[0]?.amount_collected ?? 0],
                backgroundColor: ["#36a2eb", "#ff6384"]
            }
        ]
    };

    const barOptions = {
        responsive: true,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const value = context.raw;
                        return new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD"
                        }).format(value);
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value) {
                        return new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD"
                        }).format(value);
                    }
                }
            }
        }
    };


    return (
        <>
            <Col sm="12" className='p-l-0 p-r-0' >
                {
                    loadingFinance && <Col sm="12" md="12" lg="12" className='text-center pt-4' style={{ textAlign: "center" }}>
                        <img src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '90px' }} /> <br /> <br />
                        <label className='txt-secondary f-18'>Cargando.....</label>
                    </Col>
                }
                <Col sm="12" className={loadingFinance ? "d-none" : "p-l-0 p-r-0"} style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", transformOrigin: "top left", textAlign: "left" }}  >
                    <Row>
                        <Col sm="9" className="p-r-0 p-l-0 ">
                            {
                                // *INDICATOR DEPOSITS
                            }
                            <Row
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "8px",
                                    justifyContent: "flex-start",
                                }}
                            >
                                <Col
                                    style={{
                                        flex: "1 1 calc(16.66% - 8px)",
                                        minWidth: "150px",
                                        display:
                                            listMovements?.some(
                                                (m) => m?.id_pay_method === 1 && m?.amount != null
                                            ) ||
                                                listMovementsInvoice?.some(
                                                    (m) => m?.id_pay_method === 1 && m?.amount != null
                                                )
                                                ? "block"
                                                : "none",
                                    }}
                                    className="pt-3 p-r-0"
                                >
                                    <Col
                                        sm="12"
                                        className="col-selected-1  p-r-0"
                                        style={{ border: "solid 1px #ecf3fa", height: "60px" }}
                                    >
                                        <Row className="pt-2">
                                            <Col sm="3" className="pt-2">
                                                <div className="card-validateFinance-E">
                                                    <b className="f-14">E</b>
                                                </div>
                                            </Col>
                                            <Col sm="9">
                                                {listMovements?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 1 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-primary">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                                {listMovementsInvoice?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 1 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-danger pt-2">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Col>
                                <Col
                                    style={{
                                        flex: "1 1 calc(16.66% - 8px)",
                                        minWidth: "150px",
                                        display:
                                            listMovements?.some(
                                                (m) => m?.id_pay_method === 10 && m?.amount != null
                                            ) ||
                                                listMovementsInvoice?.some(
                                                    (m) => m?.id_pay_method === 10 && m?.amount != null
                                                )
                                                ? "block"
                                                : "none",
                                    }}
                                    className="pt-3"
                                >
                                    <Col
                                        sm="12"
                                        className="col-selected"
                                        style={{ border: "solid 1px #ecf3fa", height: "60px" }}
                                    >
                                        <Row className="pt-2">
                                            <Col sm="3" className="pt-2">
                                                <div className="card-validateFinance-C pointer">
                                                    <b className="f-14">C</b>
                                                </div>
                                            </Col>
                                            <Col sm="9">
                                                {listMovements?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 10 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-primary">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                                {listMovementsInvoice?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 10 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-danger pt-2">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Col>

                                <Col
                                    style={{
                                        flex: "1 1 calc(16.66% - 8px)",
                                        minWidth: "150px",
                                        display:
                                            listMovements?.some(
                                                (m) => m?.id_pay_method === 2 && m?.amount != null
                                            ) ||
                                                listMovementsInvoice?.some(
                                                    (m) => m?.id_pay_method === 2 && m?.amount != null
                                                )
                                                ? "block"
                                                : "none",
                                    }}
                                    className="pt-3"
                                >
                                    <Col
                                        sm="12"
                                        className="col-selected-1"
                                        style={{ border: "solid 1px #ecf3fa", height: "60px" }}
                                    >
                                        <Row className="pt-2">
                                            <Col sm="3" className="pt-2">
                                                <div className="card-validateFinance-TC">
                                                    <b className="f-12">T.C</b>
                                                </div>
                                            </Col>
                                            <Col sm="9">
                                                {listMovements?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 2 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-primary">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                                {listMovementsInvoice?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 2 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-danger pt-2">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Col>

                                <Col
                                    style={{
                                        flex: "1 1 calc(16.66% - 8px)",
                                        minWidth: "150px",
                                        display:
                                            listMovements?.some(
                                                (m) => m?.id_pay_method === 4 && m?.amount != null
                                            ) ||
                                                listMovementsInvoice?.some(
                                                    (m) => m?.id_pay_method === 4 && m?.amount != null
                                                )
                                                ? "block"
                                                : "none",
                                    }}
                                    className="pt-3"
                                >
                                    <Col
                                        sm="12"
                                        className="col-selected-1"
                                        style={{ border: "solid 1px #ecf3fa", height: "60px" }}
                                    >
                                        <Row className="pt-2">
                                            <Col sm="3" className="pt-2">
                                                <div className="card-validateFinance-TD">
                                                    <b className="f-12">T.D</b>
                                                </div>
                                            </Col>
                                            <Col sm="9">
                                                {listMovements?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 4 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-primary">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                                {listMovementsInvoice?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 4 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-danger pt-2">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Col>

                                <Col
                                    style={{
                                        flex: "1 1 calc(16.66% - 8px)",
                                        minWidth: "150px",
                                        display:
                                            listMovements?.some(
                                                (m) => m?.id_pay_method === 8 && m?.amount != null
                                            ) ||
                                                listMovementsInvoice?.some(
                                                    (m) => m?.id_pay_method === 8 && m?.amount != null
                                                )
                                                ? "block"
                                                : "none",
                                    }}
                                    className="pt-3"
                                >
                                    <Col
                                        sm="12"
                                        className="col-selected-1"
                                        style={{ border: "solid 1px #ecf3fa", height: "60px" }}
                                    >
                                        <Row className="pt-2">
                                            <Col sm="3" className="pt-2">
                                                <div className="card-validateFinance-TE">
                                                    <b className="f-12">T.E</b>
                                                </div>
                                            </Col>
                                            <Col sm="9">
                                                {listMovements?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 8 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-primary">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                                {listMovementsInvoice?.map(
                                                    (m) =>
                                                        m?.id_pay_method === 8 &&
                                                        m?.amount != null && (
                                                            <div key={m?.id_pay_method} className="txt-danger pt-2">
                                                                <b style={{ fontSize: "10px" }}>
                                                                    ${number_format(m?.amount, 2)}
                                                                </b>
                                                            </div>
                                                        )
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Col>
                            </Row>
                            {
                                // * CHART
                            }
                            <ApexCharts
                                id="chart-currently"
                                options={depositOptions}
                                series={depositSerie}
                                type="area"
                                height={330}
                            />
                            {
                                // * GLOBAL INDICATOR 
                            }
                            <Col sm="12" className='p-l-0 p-r-0' style={{ backgroundColor: "#f8f9fa", border: "#e9ecef 1px solid" }} >
                                <Row className='pt-4 pb-4 pr-3 pl-3' >
                                    <Col sm="3">
                                        <div className="info-card">
                                            <img
                                                src={require('../../assets/images/dashboard/Ticket.svg')}
                                                alt="Ticket Icon"
                                            />
                                            <label>Ticket promedio</label>
                                            <b>${number_format(_ticket ?? 0, 2)}</b>
                                        </div>
                                    </Col>

                                    <Col sm="3">
                                        <div className="info-card">
                                            <img
                                                src={require('../../assets/images/dashboard/TotalCuenta.svg')}
                                                alt="Total Cuenta Icon"
                                            />
                                            <label>Total en cuenta</label>
                                            <b> ${number_format(totalDepositSend ?? 0, 2)} </b>
                                        </div>
                                    </Col>

                                    <Col sm="3" onClick={() => handlePayment()} >
                                        <div className="info-card">
                                            <img
                                                src={require('../../assets/images/dashboard/TotalMeses.svg')}
                                                alt="Ingreso Meses Icon"
                                            />
                                            <label>Ingreso de otros meses</label>
                                            <b>  ${number_format(totalComplement ?? 0, 2)}</b>
                                        </div>
                                    </Col>

                                    <Col sm="3">
                                        <div className="info-card">
                                            <img
                                                src={require('../../assets/images/dashboard/TotalPersonas.svg')}
                                                alt="Pacientes Icon"
                                            />
                                            <label>Total de pacientes</label>
                                            <b>{indicatorPatient ?? 0}</b>
                                        </div>
                                    </Col>

                                </Row>
                            </Col>
                        </Col>
                        {
                            // ! CONFIGURATION INGRESS
                        }
                        <Col sm="3">
                            <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "15px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "165%", transformOrigin: "top left", textAlign: "center", height: "99%" }}>
                                <div
                                    style={{
                                        fontWeight: 'bold',
                                        padding: '8px',
                                        borderRadius: '8px',
                                        marginBottom: '10px',
                                        fontSize: '14px',
                                        color: "#002940",
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    <i className='icofont icofont-filter f-20' ></i> <label className='pt-2' >Filtros</label>

                                    <DateRangePicker
                                        initialSettings={{
                                            startDate: start_date,
                                            endDate: end_date,
                                            locale: {
                                                format: "YYYY-MM-DD",
                                                applyLabel: "Aplicar",
                                                cancelLabel: "Cancelar"
                                            }
                                        }}
                                        onApply={(event, picker) => {
                                            const start = picker.startDate.format("YYYY-MM-DD");
                                            console.log("🚀 ~ ProgrammingDeposits ~ start:", start)
                                            const end = picker.endDate.format("YYYY-MM-DD");
                                            console.log("🚀 ~ ProgrammingDeposits ~ end:", end)

                                            handleInputChange({ target: { name: "start_date", value: start } });
                                            handleInputChange({ target: { name: "end_date", value: end } });

                                            handleActions(start, end);
                                        }}
                                    >
                                        <input
                                            className="form-control form-control-sm input-air-primary border-primary-input"
                                            value={`${start_date} - ${end_date}`}
                                            readOnly
                                        />
                                    </DateRangePicker>
                                </div>

                                <Col sm="12">
                                    <div className='payment-step'>
                                        <div className='step-header'>
                                            <div className='step-number'>A</div>
                                            {leftContents}
                                        </div>
                                    </div>

                                    <div className='payment-step ' >
                                        <div className='step-header' >
                                            <div className='step-number2'>B</div>
                                            {leftContents1}
                                        </div>
                                    </div>

                                    <div className='payment-step ' >
                                        <div className='step-header' >
                                            <div className='step-number2'>B</div>
                                            {leftContents2}
                                        </div>
                                    </div>

                                    <div className='payment-step ' >
                                        <div className='step-header' >
                                            <div className='step-number3'>F</div>
                                            {leftContents3}
                                        </div>
                                    </div>
                                </Col>
                            </Card>
                        </Col>
                    </Row>
                    {
                        //  ! CONFIGURATION B
                    }
                    <Col sm="12" className='p-l-0 p-r-0' >
                        <Row>
                            <Col sm="6">
                                <Card className='shadow-sm border height-equal  mb-0 pb-0 p-3' style={{ transform: "scale(0.9)", width: "110%", transformOrigin: "top left", textAlign: "center", height: "99%" }} >
                                    <div style={{
                                        fontWeight: 'bold',
                                        background: 'linear-gradient(90deg, #3b82f6, #60a5fa)',
                                        color: 'white',
                                        padding: '8px 0',
                                        borderRadius: '8px',
                                        marginBottom: '15px',
                                        textAlign: 'center',
                                        fontSize: '14px'
                                    }}>
                                        Configuración de flujo
                                    </div>
                                    <Col sm="12" className='p-l-0 p-r-0' >
                                        <DataTable
                                            value={detailBranch.flatMap(branch => branch.children)}
                                            responsiveLayout="scroll"
                                        >
                                            <Column
                                                headerStyle={headerStyle}
                                                header="Sucursales"
                                                body={(row) => (
                                                    <Col sm="12" className='badge-detail-Finance'>
                                                        <Row>
                                                            <Col sm="3" className='p-r-0'>
                                                                <i className="fa fa-angle-right f-12"></i>
                                                            </Col>
                                                            <Col sm="9" className='p-l-0 p-r-0' style={{ textAlign: "justify" }}>
                                                                {row.text ?? "--"}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                )}
                                                style={centerStyle}
                                            />
                                            <Column
                                                headerStyle={headerStyle}
                                                header="Ingresado en el sistema"
                                                body={(row) => {
                                                    const _detail = getBranchDetails(row);
                                                    return <b style={{ color: "#818a91" }}>${number_format(_detail?.amount, 2) ?? 0}</b>;
                                                }}
                                                style={centerStyle}
                                            />

                                            <Column
                                                headerStyle={headerStyle}
                                                header="Programado en serie B"
                                                body={(row) => {
                                                    return <b style={{ color: "#818a91" }}>${number_format(row?.amount, 2) ?? 0}</b>;
                                                }}
                                                style={centerStyle}
                                            />

                                            <Column
                                                headerStyle={headerStyle}
                                                header="Recuperado en serie B"
                                                body={(row) => {
                                                    const _validColor = row?.amount_collected === row?.amount ? "txt-success" : "txt-danger";
                                                    return <b className={_validColor}>${number_format(row?.amount_collected, 2) ?? 0}</b>;
                                                }}
                                                style={centerStyle}
                                            />

                                            <Column
                                                headerStyle={headerStyle}
                                                header="Ingreso con flujo B"
                                                body={(row) => {
                                                    const _detail = getBranchDetails(row);
                                                    const total = calculateTotal(row, _detail);
                                                    return <b style={{ color: "#818a91" }}>${number_format(total, 2) ?? 0}</b>;
                                                }}
                                                style={centerStyle}
                                            />
                                        </DataTable>
                                    </Col>
                                </Card>

                            </Col>

                            <Col sm="6">
                                <Card className="shadow-sm border p-3" style={{ transform: "scale(0.9)", width: "140%", transformOrigin: "top left", textAlign: "center", height: "99%" }} >
                                    <div style={{
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        marginBottom: '15px',
                                        color: '#3b82f6',
                                        textAlign: 'center'
                                    }}>
                                    </div>

                                    <Row>
                                        <Col sm="5" className="d-flex flex-column align-items-center">
                                            <div style={{
                                                fontWeight: 'bold',
                                                fontSize: '12px',
                                                marginBottom: '10px',
                                                color: '#3b82f6',
                                                textAlign: 'center'
                                            }}>
                                                Flujo A y Flujo B
                                            </div>
                                            <div style={{
                                                width: '100%',
                                                maxWidth: '255px',
                                                background: '#f9fafb',
                                                borderRadius: '15px',
                                                padding: '10px',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                            }}>
                                                <Doughnut data={doughnutData} options={doughnutOptions} />
                                            </div>
                                        </Col>


                                        <Col sm="7" className="d-flex flex-column align-items-center">
                                            <div style={{
                                                fontWeight: 'bold',
                                                fontSize: '12px',
                                                marginBottom: '10px',
                                                color: '#3b82f6',
                                                textAlign: 'center'
                                            }}>
                                                Programación del flujo
                                            </div>

                                            <div style={{
                                                width: '100%',
                                                maxWidth: '100%',
                                                background: '#f9fafb',
                                                borderRadius: '15px',
                                                padding: '10px',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                            }}>
                                                <Bar data={barData} options={barOptions} />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>


                            <Col sm="12">
                            </Col>

                        </Row>

                    </Col>

                </Col>
            </Col>

        </>
    )

}
